<template>
  <div class="filtrate">
    <header v-show="knowledgeName">
      <p>{{ knowledgeName }}</p>
    </header>
    <ul
      class="questionCode"
      :class="[1, 3].includes(Number(this.categoryObj.subjectId)) ? 'border-line' : ''"
      v-if="[1, 3].includes(Number(this.categoryObj.subjectId)) && !tagSelect"
    >
      <li class="filtrate-strong">知识点 :</li>
      <li
        class="filtrate-text"
        :class="{ active: tagCode === '' }"
        @click="onChangeList('questionCode', '')"
        v-if="isWong"
      >
        <!-- 共性错题才展示全部 -->
        全部知识点
      </li>
      <li
        class="filtrate-text filtrate-dot"
        v-for="(item, index) in selectTagArray"
        :class="{ active: tagCode === item.tag_code}"
        :key="index"
        @click="onChangeList('questionCode', item.tag_code)"
      >
        {{ item.tag_name }}
      </li>
    </ul>
    <section v-if="![1, 3].includes(Number(this.categoryObj.subjectId))">
      <ul class="filtrate-border">
        <li class="filtrate-strong">题型 :</li>
        <li
          class="filtrate-text"
          :class="{ active: questionNumber === '' }"
          @click="onChangeList('questionType', '')"
        >
          全部
        </li>
        <li
          class="filtrate-text filtrate-dot"
          v-for="(item, index) in questionType"
          :class="{ active: questionNumber === item.questionType }"
          :key="index"
          @click="onChangeList('questionType', item.questionType)"
        >
          {{ item.name }}
        </li>
      </ul>
      <ul class="filtrate-dotted">
        <li class="filtrate-strong">
          题目难度
          <el-popover
            placement="top-start"
            title="题目难度说明"
            width="150"
            trigger="hover"
          >
            <img slot="reference" src="../../images/question-mark.png" />
            10 ~ 30 <span style="margin-left: 10px">简单题目</span>
            <br />
            40 ~ 60 <span style="margin-left: 10px">中等难度题目</span>
            <br />
            70 ~ 90 <span style="margin-left: 10px">较难题目</span>
          </el-popover>
          :
        </li>
        <li
          class="filtrate-text"
          :class="{ active: difficultyNumber === '' }"
          @click="onChangeList('difficultyLevel', '')"
        >
          全部
        </li>
        <li
          class="filtrate-text filtrate-dot"
          v-for="(kitem, index) in difficultyLevel"
          :key="index"
          :class="{ active: difficultyNumber === kitem }"
          @click="onChangeList('difficultyLevel', kitem)"
        >
          {{ kitem }}
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Filtrate',
  props: {
    isWong: {
      type: Boolean,
      default: false,
    },
    knowledgeName: {
      type: String,
      default: '',
    },
    type: {
      default: true,
    },
  },
  computed: {
    ...mapGetters(['categoryObj', 'selectTagArray']),
    tagSelect() {
      return this.selectTagArray.some((item) => item.active);
    },
  },
  data() {
    return {
      questionType: [
        { name: '单选题', questionType: 1 },
        { name: '多选题', questionType: 2 },
        { name: '填空题', questionType: 3 },
        { name: '判断题', questionType: 4 },
      ],
      questionNumber: '',
      difficultyLevel: [10, 20, 30, 40, 50, 60, 70, 80, 90],
      difficultyNumber: '',
      tagCode: '',
    };
  },
  methods: {
    onChangeList(value, item) { // 切换
      if (value === 'questionType') {
        this.questionNumber = item;
      }
      if (value === 'difficultyLevel') {
        this.difficultyNumber = item;
      }
      if (value === 'questionCode') {
        this.tagCode = item;
        console.log('here', this.tagCode);
      }
      this.$emit('clearPage', value, item);
      //
    },
  },
};
</script>

<style lang="scss" scoped>
.filtrate {
  background: #ffffff;
  margin-bottom: 60px;
  border-radius: 2px;
  position: relative;
  header {
    height: 30px;
    line-height: 30px;
    margin-left: 40px;
    margin-top: 17px;
    background: url("~@/views/pt/images/class_bg.png") no-repeat left;
    background-size: 38px 29px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    p {
      padding-left: 6px;
      padding-bottom: 6px;
      border-bottom: 1px dotted #dce1eb;
    }
  }
  .box {
    position: absolute;
    top: 22px;
    left: 50px;
  }
  #more {
    position: absolute;
    left: 121px;
    top: 14px;
    line-height: 38px;
  }
  &-strong {
    width: 96px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    text-align: end;
    color: #000000;
    img {
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
  }
  .active {
    border-radius: 5px;
    color: #ffffff;
    background-color: #1989fa;
    &:hover {
      color: #fff !important;
    }
  }
  .border-line {
    min-height: 124px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    min-width: 800px;
  }
  ul {
    margin-top: 24px;
    margin-left: 40px;
    line-height: 66px;
    li {
      line-height: 24px;
      padding: 7px 12px;
      display: inline-block;
      margin: 0 12px;
      cursor: pointer;
    }
  }
  &-knowledge {
    // display: flex;
    // justify-content: space-around;
    position: relative;
    overflow: hidden;
    height: 63px;
    ul {
      width: 75%;
      margin-right: 10px;
    }
  }
  &-text {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #303133;
  }
  &-dot {
    line-height: 24px;
    &:hover {
      color: rgba(25, 137, 250, 1);
    }
  }
  &-border {
    border-bottom: 1px solid #dce1eb;
  }
  &-dotted {
    border-bottom: 1px dotted #dce1eb;
  }
  &-more {
    position: absolute;
    right: -24px;
    top: 24px;
    width: 100px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #1989fa;
    line-height: 14px;
    & /deep/ .el-icon-arrow-up:before {
      content: "\e6e1";
    }
  }
}
</style>
